import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './landingpage/landingpage.component';

const pages: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    data: {
      title: 'Landingpage',
      bodyClass: 'l-landingpage',
    },
  },
  {
    path: 'news',
    loadChildren: () => import('../app/news/news.module').then((m) => m.NewsModule),
  },
  {
    path: 'get-started',
    loadChildren: () => import('../app/get-started/get-started.module').then((m) => m.GetStartedModule),
  },
  {
    path: 'documentation',
    loadChildren: () => import('../app/documentation/documentation.module').then((m) => m.DocumentationModule),
  },
  {
    path: 'editor',
    loadChildren: () => import('../app/config-editor/config-editor.module').then((m) => m.PFEConfigEditorModule),
  },
];

const routes: Routes = [...pages];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // enableTracing: true,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
